module.exports = __webpack_public_path__ + "img/expert-elena-qr.a6d65852.png";